import React, { FC } from 'react';
import { Modal } from '@mui/material';
import { StyledModalContent } from './styled';
import { SimpleModalProps } from './types';

const SimpleModalNew: FC<SimpleModalProps> = ({ children, isOpen, handleClose = () => null, width, maxWidth, height }) => {
  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      slotProps={{
        backdrop: {
          style: {
            backgroundColor: '#000',
            opacity: 0.8,
          },
        },
      }}
    >
      <StyledModalContent width={width} maxWidth={maxWidth} height={height}>
        {children}
      </StyledModalContent>
    </Modal>
  );
};

export default SimpleModalNew;
